import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import React from 'react';

const globalStyleRules = {
  '*': {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  },
  'body': {
    fontFamily: "'Lato', Arial, sans-serif",
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    transition: 'background-color 0.15s ease-in-out',
  },
  'h1, h2, h3, h4, h5, h6': {
    fontFamily: "'Roboto', Arial, sans-serif",
    transition: 'none',
  },
  'p, span, div': {
    transition: 'none',
  },
};

export const globalStyles = React.createElement(MuiGlobalStyles, { styles: globalStyleRules });